import React from 'react';
import CollapsibleSection from '../../common/CollapsibleSection';
import SessionMonitoring from '../SessionMonitoring';

/**
 * Archived sessions — filed records, separate from Past (completed, not yet archived).
 */
const SessionsArchivedSection = ({
  clubId,
  defaultExpanded = false,
  completedSessionAllMarked = null,
  onSessionsChange,
  clubLogoUrl = null,
  clubName = '',
  expanded,
  onExpandedChange,
}) => {
  if (!clubId) return null;

  return (
    <div id="sessions-archived-section">
      <CollapsibleSection
        title="Archived sessions"
        iconType="archive"
        defaultExpanded={defaultExpanded}
        expanded={expanded}
        onExpandedChange={onExpandedChange}
        className="mb-0"
      >
        <SessionMonitoring
          clubId={clubId}
          embedded
          variant="archived"
          completedSessionAllMarkedFromHub={completedSessionAllMarked}
          onSessionsChange={onSessionsChange}
          clubLogoUrl={clubLogoUrl}
          clubName={clubName}
        />
      </CollapsibleSection>
    </div>
  );
};

export default SessionsArchivedSection;
